import CrudRepository from './CrudRepository'
export default class FaqsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/FAQ/category')
  }
}
